import React from "react"
import PropTypes from "prop-types"
import { graphql } from "gatsby"
import Container from "components/Container"
import theme from "styles/theme"
import TextBlock from "components/TextBlock"
import BlockHeader from "components/BlockHeader"

const SimpleTextBlock = ({ label, title, content }) => (
  <Container
    max={942}
    wrapperStyles={theme.expandQueries({
      padding: ["80px 74px", "60px 74px", "45px 40px"],
    })}
  >
    <BlockHeader
      label={label}
      title={title}
      css={theme.expandQueries({
        marginBottom: [60, 50, 30],
      })}
    />
    <TextBlock>{content}</TextBlock>
  </Container>
)

export default SimpleTextBlock

SimpleTextBlock.propTypes = {
  label: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  content: PropTypes.array.isRequired,
}

export const query = graphql`
  fragment SimpleTextBlock on SanitySimpleTextBlock {
    label
    title
    content: _rawContent
  }
`
